import { combineReducers } from '@reduxjs/toolkit';

import currentUserReducer from 'state/current-user/current-user.slice';
import insightReducer from 'state/insight/insight.slice';

const rootReducer = combineReducers({
  currentUser: currentUserReducer,
  insight: insightReducer,
});

export default rootReducer;
